module.exports = __webpack_public_path__ + "img/certificate-EC-Excellent.b9f328b4.jpg";